





































































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {
  AlcoholTestState,
  isNorthEastAndNorthCumbria,
  Question,
  RiskLevelForScore,
  RiskTypeNameForScore
} from "@/model/Model";
import {RiskLevel} from "@/model/RiskLevel";
import {LogEvent, removeWidows, ScrollToTop, UpdatedHeight} from "@/utils";
import TestResultsSummary from "./TestResultsSummary.vue";
import UnitsExplanation from "./UnitsExplanation.vue";
import DrinkingComparison from "./DrinkingComparison.vue";
import RisksAnalysis from "./RisksAnalysis.vue";
import DownloadDrinkCoachApp from "./DownloadDrinkCoachApp.vue";
import DrinkCoachAppointment from "./DrinkCoachAppointment.vue";
import ThankYouPage from "./ThankYouPage.vue";
import FindSupport from "./FindSupport.vue";
import CreateAPlan from "./CreateAPlan.vue";
import AmIAlcoholic from "./AmIAlcoholic.vue";
import NencWellbeingHub from "./NencWellbeingHub.vue";
import SignUpForOnlineCoaching from "./SignUpForOnlineCoaching.vue";
import SelfReferral from "./SelfReferral.vue";
import MoreAboutYourDrinking from "./MoreAboutYourDrinking.vue";
import CallbackForm from "./CallbackForm.vue";
import {Borough} from "@/model/Boroughs";
import {UserInteractionEvent} from "@/model/UserEvents";

const sectionsLowerRisk = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  DownloadDrinkCoachApp,
  ThankYouPage
];

const sectionsIncreasingRisk = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  CreateAPlan,
  FindSupport,
  DrinkCoachAppointment,
  DownloadDrinkCoachApp,
  ThankYouPage
];

const sectionsIncreasingRiskFreeAppointments = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  CreateAPlan,
  DrinkCoachAppointment,
  FindSupport,
  DownloadDrinkCoachApp,
  ThankYouPage
];


const sectionsHigherRisk = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  AmIAlcoholic,
  CreateAPlan,
  FindSupport,
  DrinkCoachAppointment,
  DownloadDrinkCoachApp,
  ThankYouPage
];

const sectionsHigherRiskFreeAppointments = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  AmIAlcoholic,
  CreateAPlan,
  DrinkCoachAppointment,
  FindSupport,
  DownloadDrinkCoachApp,
  ThankYouPage
];

const sectionsHighRisk = [
  TestResultsSummary,
  UnitsExplanation,
  DrinkingComparison,
  RisksAnalysis,
  AmIAlcoholic,
  FindSupport,
  DownloadDrinkCoachApp,
  ThankYouPage
];

const sectionsLowerRiskNonCommissioned = [
  TestResultsSummary,
  SignUpForOnlineCoaching,
  MoreAboutYourDrinking,
  DownloadDrinkCoachApp
];

const sectionsIncreasingRiskNonCommissioned = [
  TestResultsSummary,
  SignUpForOnlineCoaching,
  MoreAboutYourDrinking,
  FindSupport,
  DrinkCoachAppointment,
  DownloadDrinkCoachApp
];

const sectionsHigherRiskNonCommissioned = [
  TestResultsSummary,
  SignUpForOnlineCoaching,
  MoreAboutYourDrinking,
  FindSupport,
  DrinkCoachAppointment,
  DownloadDrinkCoachApp
];

const sectionsHighRiskNonCommissioned = [
  TestResultsSummary,
  SignUpForOnlineCoaching,
  MoreAboutYourDrinking,
  FindSupport,
  DownloadDrinkCoachApp
];

if (isNorthEastAndNorthCumbria()) {
  (sectionsLowerRiskNonCommissioned as any[]).push(NencWellbeingHub);
  (sectionsIncreasingRiskNonCommissioned as any[]).push(NencWellbeingHub);
  (sectionsHigherRiskNonCommissioned as any[]).push(NencWellbeingHub);
  (sectionsHighRiskNonCommissioned as any[]).push(DrinkCoachAppointment, NencWellbeingHub);
}

@Component({
  components: {
    TestResultsSummary,
    CallbackForm,
    AmIAlcoholic: () =>
      import(/* webpackChunkName: "am-i-alcoholic" */ "./AmIAlcoholic.vue"),
    UnitsExplanation: () =>
      import(
        /* webpackChunkName: "units-explanation" */ "./UnitsExplanation.vue"
      ),
    DrinkingComparison: () =>
      import(
        /* webpackChunkName: "drinking-comparison" */ "./DrinkingComparison.vue"
      ),
    RisksAnalysis: () =>
      import(/* webpackChunkName: "risks-analysis" */ "./RisksAnalysis.vue"),
    CreateAPlan: () =>
      import(/* webpackChunkName: "plan-creator" */ "./CreateAPlan.vue"),
    FindSupport: () =>
      import(/* webpackChunkName: "support-finder" */ "./FindSupport.vue"),
    DownloadDrinkCoachApp: () =>
      import(
        /* webpackChunkName: "download-app" */ "./DownloadDrinkCoachApp.vue"
      ),
    DrinkCoachAppointment: () =>
      import(
        /* webpackChunkName: "make-appointment" */ "./DrinkCoachAppointment.vue"
      ),
    ThankYouPage: () =>
      import(/* webpackChunkName: "thank-you" */ "./ThankYouPage.vue"),
    NencWellbeingHub: () =>
        import(/* webpackChunkName: "nenc-wellbeing-hub" */ "./NencWellbeingHub.vue"),
    SignUpForOnlineCoaching: () =>
        import(/* webpackChunkName: "signup-online-coaching" */ "./SignUpForOnlineCoaching.vue"),
    SelfReferral: () =>
        import(/* webpackChunkName: "self-referral" */ "./SelfReferral.vue")
  }
})
export default class TestResults extends Vue {
  @Prop() public state!: AlcoholTestState;
  @Prop() public score!: number;
  @Prop() public steps!: Question[];
  @Prop() public navRequested!: string;
  @Prop() public isMobile!: boolean;
  @Prop() public region!: Borough;
  @Prop() public scrollOffset!: { offset: number };

  private showNav: boolean = false;
  private internalSectionNum: number = 0;
  private prevPressed: boolean = false;
  private nextPressed: boolean = false;
  private ribbonPressed: boolean = false;
  private showedPrompt: boolean = false;

  private prevSection: number = -1;

  public created() {
    LogEvent(
      UserInteractionEvent.RiskLevel,
      `${RiskTypeNameForScore(this.score)}-risk`
    );
    if (
      this.navRequested === "" &&
      RiskLevelForScore(this.score) === RiskLevel.High
    ) {
      this.$emit("show-confirmation-prompt", {
        prompt: {
          label:
            "Your score indicates High Risk / Possible Dependence. " +
            "We strongly recommend seeking advice from a health professional.",
          confirmText: "View full results."
        },
        onConfirmation: () => {
          this.maybeShowLewishamCallbackForm();
          return;
        }
      });
    } else {
      this.maybeShowLewishamCallbackForm();
    }
  }

  public maybeShowLewishamCallbackForm(): void {
    if (this.region.name === "Lewisham") {
      setTimeout(() => {
        this.$emit("show-confirmation-prompt", {
          prompt: {
            label: "",
            confirmText: "Dismiss",
            component: CallbackForm
          },
          onConfirmation: () => {
            return;
          }
        });
      }, 5000);
    }
  }

  public updated() {
    UpdatedHeight();
  }

  public mounted() {
    this.$nextTick(() => {
      UpdatedHeight();
      this.$nextTick(() => {
        UpdatedHeight();
      });
    });
  }

  private get hasFreeAppointments(): boolean {
    return !!this.region.hasFreeAppointments;
  }

  private get specialStaffGroup(): boolean {
    const targetQuestion = this.steps[this.steps.length - 1].inputs.find(({label}) => label === "What best describes your staff group?");
    const group = (targetQuestion && targetQuestion.selected && targetQuestion.selected.label) || null;
    return (
        group !== null &&
        ["Doctor", "Dental health practitioner", "Manager/commissioner"].includes(group)
    ) || false;
  }

  private removeWidows(str: string): string {
    return removeWidows(str);
  }

  private get summary(): object {
    return TestResultsSummary;
  }

  private get offsetTop(): number {
    return Math.min(
      document.body.offsetHeight,
      Math.max(this.scrollOffset.offset, 80)
    );
  }

  private isRecommendedSection(section: any): boolean {
    const riskLevel = RiskLevelForScore(this.score);
    if (riskLevel === RiskLevel.Lower && section === DownloadDrinkCoachApp) {
      return true;
    } else if (
        (
            ["South Tyneside", "Sheffield", "Northumberland"].includes(this.region.name)
        ) &&
      riskLevel === RiskLevel.Higher &&
      section === FindSupport
    ) {
      return true;
    } else if ([
        "Sheffield",
        "Northumberland"
    ].includes(this.region.name) && riskLevel === RiskLevel.Increasing && section === FindSupport) {
      return true;
    } else if (
        (this.region.name === "South Tyneside") &&
      riskLevel === RiskLevel.Increasing &&
      section === CreateAPlan
    ) {
      return true;
    } else if (
      // Special case for county durham + cumbria
        (["County Durham", "Cumbria", "Dudley"].includes(this.region.name)) &&
      (riskLevel === RiskLevel.Increasing || riskLevel === RiskLevel.Higher) &&
      section === CreateAPlan
    ) {
      return true;
    } else if (
      ((this.region.name === "Tower Hamlets" &&
          riskLevel === RiskLevel.Increasing)) &&
      (riskLevel === RiskLevel.Increasing || riskLevel === RiskLevel.Higher) &&
      section === CreateAPlan
    ) {
      return true;
    } else if (
      this.region.name !== "Leeds" &&
      this.region.name !== "South Tyneside" &&
      (riskLevel === RiskLevel.Increasing || riskLevel === RiskLevel.Higher) &&
      section === DrinkCoachAppointment
    ) {
      return true;
    } else if (
      ((this.region.name === "Tower Hamlets" &&
        (riskLevel === RiskLevel.High || riskLevel === RiskLevel.Higher)) ||
        riskLevel === RiskLevel.High && !["NorthEastAndNorthCumbria", "West Sussex"].includes(this.region.name)) &&
      section === FindSupport
    ) {
      return true;
    } else if (
      this.region.name === "Leeds" &&
      riskLevel === RiskLevel.Higher &&
      section === FindSupport
    ) {
      return true;
    } else if (
      this.region.name === "Leeds" &&
      riskLevel === RiskLevel.Increasing &&
      section === DrinkCoachAppointment
    ) {
      return true;
    } else if (
      ["NorthEastAndNorthCumbria", "West Sussex"].includes(this.region.name) &&
      riskLevel === RiskLevel.High &&
      section === DrinkCoachAppointment
    ) {
      return true;
    }
    return false;
  }

  private get isResultsLanding(): boolean {
    return this.sections[this.sectionNum] === TestResultsSummary;
  }

  private get isResultsReadMore(): boolean {
    return (
      this.sections[this.sectionNum] === TestResultsSummary &&
      this.isCommissioned
    );
  }

  private get sections(): any[] {
    const riskLevel = RiskLevelForScore(this.score);
    const additions = [] as any[];
    if (this.isCommissioned) {
      if (
          ["Bradford District", "Suffolk", "Croydon", "West Sussex", "Oxfordshire"].includes(this.region.name)
          &&
          (riskLevel === RiskLevel.High)
      ) {
        additions.push(DrinkCoachAppointment);
      }
      let sectionsFiltered;
      switch (riskLevel) {
        case RiskLevel.Lower:
          sectionsFiltered = sectionsLowerRisk;
          break;
        case RiskLevel.Increasing:
          if (this.hasFreeAppointments) {
            sectionsFiltered = sectionsIncreasingRiskFreeAppointments;
          } else {
            sectionsFiltered = sectionsIncreasingRisk;
          }
          break;
        case RiskLevel.Higher:
          if (this.hasFreeAppointments) {
            sectionsFiltered = sectionsHigherRiskFreeAppointments;
          } else {
            sectionsFiltered = sectionsHigherRisk;
          }
          break;
        case RiskLevel.High:
        default:
          sectionsFiltered = sectionsHighRisk;
          break;
      }
      if (
          [
              "Tower Hamlets",
              "County Durham",
              "Dudley",
              "Cumbria",
              "South Tyneside",
              "Sheffield",
              "Northumberland"
          ].includes(this.region.name)
      ) {
        // NOTE(jon): This region doesn't allow endorsement of services they haven't explicitly
        // commissioned, so remove the drinkcoach online appointments page
        return sectionsFiltered.filter(item => item !== DrinkCoachAppointment);
      }
      return [...sectionsFiltered, ...additions];
    } else {
      switch (riskLevel) {
        case RiskLevel.Lower:
          return (
              this.specialStaffGroup ?
                  [...sectionsLowerRiskNonCommissioned, SelfReferral]
                  : [...sectionsLowerRiskNonCommissioned, ...additions]
          );
        case RiskLevel.Increasing:
          return (
              this.specialStaffGroup ?
                  [...sectionsIncreasingRiskNonCommissioned, SelfReferral]
                  : [...sectionsIncreasingRiskNonCommissioned, ...additions]
          );
        case RiskLevel.Higher:
          return (
              this.specialStaffGroup ?
                  [...sectionsHigherRiskNonCommissioned, SelfReferral]
                  : [...sectionsHigherRiskNonCommissioned, ...additions]
          );
        case RiskLevel.High:
        default:
          return (this.specialStaffGroup ?
              [...sectionsHighRiskNonCommissioned, SelfReferral]
              : [...sectionsHighRiskNonCommissioned, ...additions]
          );
      }
    }
  }

  private get isCommissioned(): boolean {
    return !(["Other", "NorthEastAndNorthCumbria"].includes(this.state.region().name));
  }

  @Emit("nav-response")
  private handledNavigation() {
    return;
  }

  private get sectionNum(): number {
    if (this.navRequested) {
      this.handleNavigation(this.navRequested);
      this.handledNavigation();
    }
    return Math.max(
      0,
      Math.min(this.sections.length - 1, this.internalSectionNum)
    );
    // return this.sections.indexOf(CreateAPlan);
  }

  private set sectionNum(num: number) {
    this.prevSection = this.internalSectionNum;
    const newSection = Math.max(0, Math.min(this.sections.length - 1, num));

    if (this.state.region().name === "NorthEastAndNorthCumbria") {
      if (this.sections[newSection] === FindSupport) {
        window.open("https://northeastnorthcumbria.nhs.uk/our-work/workstreams/health-and-prevention/alcohol-programme/alcohol-support-services/", "_blank");
        LogEvent(UserInteractionEvent.LaunchUrl, "https://northeastnorthcumbria.nhs.uk/our-work/workstreams/health-and-prevention/alcohol-programme/alcohol-support-services/");
        return;
      }
      if (this.sections[newSection] === NencWellbeingHub) {
        window.open("https://northeastnorthcumbria.nhs.uk/staff-wellbeing-hub/", "_blank");
        LogEvent(UserInteractionEvent.LaunchUrl, "https://northeastnorthcumbria.nhs.uk/staff-wellbeing-hub/");
        return;
      }
      if (this.sections[newSection] === SelfReferral) {
        window.open("https://www.practitionerhealth.nhs.uk/accessing-the-service", "_blank");
        LogEvent(UserInteractionEvent.LaunchUrl, "https://www.practitionerhealth.nhs.uk/accessing-the-service");
        return;
      }
    } else if (this.state.region().name === "Sheffield") {
      window.open("https://likewisesheffield.org.uk/get-help/#online-referral", "_blank");
      LogEvent(UserInteractionEvent.LaunchUrl, "https://likewisesheffield.org.uk/get-help/#online-referral");
      return;
    } else if (["Other"].includes(this.state.region().name)) {
      if (this.sections[newSection] === SignUpForOnlineCoaching) {
        window.open("http://eepurl.com/iwmTgE", "_blank");
        LogEvent(UserInteractionEvent.LaunchUrl, "http://eepurl.com/iwmTgE");
        return;
      }
    }

    this.scrollToTop();
    LogEvent(
      UserInteractionEvent.LoadSection,
      this.sections[newSection].navButtonLabel(this.state.region())
    );

    if (this.internalSectionNum !== newSection) {
      this.internalSectionNum = newSection;
    }
  }

  private get shouldShowNav(): boolean {
    return (
      !this.isCommissioned ||
      this.showNav ||
      this.sectionNum === this.sections.length - 1
    );
  }

  private get riskType(): string {
    return RiskTypeNameForScore(this.score);
  }

  private previousSection() {
    this.prevPressed = false;

    if (this.prevSection !== -1) {
      this.sectionNum = this.prevSection;
    } else if (this.state.region().name === "NorthEastAndNorthCumbria") {
      const newSection = Math.max(0, Math.min(this.sections.length - 1, this.sectionNum - 1));
      if (this.sections[newSection] === FindSupport) {
        this.sectionNum -= 2;
      } else {
        this.sectionNum -= 1;
      }
    } else {
      this.sectionNum -= 1;
    }

    this.prevSection = -1;
  }

  private nextSection() {
    this.nextPressed = false;
    if (this.state.region().name === "NorthEastAndNorthCumbria") {
      const newSection = Math.max(0, Math.min(this.sections.length - 1, this.sectionNum + 1));
      if (this.sections[newSection] === FindSupport) {
        this.sectionNum += 2;
      } else {
        this.sectionNum += 1;
      }
    } else {
      this.sectionNum += 1;
    }
  }

  private getComponentForResultsPage(): any {
    return this.sections[this.sectionNum];
  }

  private toggleNav() {
    this.showNav = !this.showNav;
  }

  private scrollToTop() {
    if (window.parent === window) {
      const top = (document.getElementById("test-results") as HTMLDivElement)
        .offsetTop;
      this.$nextTick(() => {
        window.scrollTo(0, top);
      });
      setTimeout(() => {
        window.scrollTo(0, top);
      }, 100);
    } else {
      ScrollToTop();
    }
  }

  private setSection(sectionNum: number) {
    this.sectionNum = sectionNum;
  }

  private handleNavigation(event: string) {
    switch (event) {
      case "find-support":
        if (this.region.name === "Sheffield") {
          window.open("https://likewisesheffield.org.uk/get-help/#online-referral", "_blank");
          LogEvent(UserInteractionEvent.LaunchUrl, "https://likewisesheffield.org.uk/get-help/#online-referral");
        } else {
          this.sectionNum = this.sections.indexOf(FindSupport);
        }
        break;
      case "book-appointment":
        this.sectionNum = this.sections.indexOf(DrinkCoachAppointment);
        break;
      case "retake-test":
        this.scrollToTop();
        this.retakeAlcoholTest();
        break;
    }
  }

  private clickedSmallRibbon(event: Event) {
    return;
  }

  @Emit("retake-alcohol-test")
  private retakeAlcoholTest() {
    return;
  }
}
